import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./assets/scss/_toast.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import CountryFlag from "vue-country-flag-next";
import "./registerServiceWorker";
import * as Sentry from "@sentry/vue";
import { captureConsoleIntegration } from "@sentry/integrations";

// import { StripePlugin } from "@vue-stripe/vue-stripe";

// const options = {
//   pk: process.env.STRIPE_PUBLISHABLE_KEY,
//   stripeAccount: process.env.STRIPE_ACCOUNT,
//   apiVersion: process.env.API_VERSION,
//   locale: process.env.LOCALE,
// };

const app = createApp(App);

if (process.env.VUE_APP_SENTRY_DNS) {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DNS,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      captureConsoleIntegration(['warn', 'error',]),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}


app.component("country-flag", CountryFlag)
  .use(store)
  .use(router)
  // .use(StripePlugin, options)
  .use(Toast, {
    transition: "Vue-Toastification__fade",
    position: POSITION.BOTTOM_CENTER,
    timeout: 2000,
    maxToasts: 1,
    icon: false,
    hideProgressBar: true,
    draggable: true,
    draggablePercent: 0.4,
  });
app.mount("#app");
